module.exports = __webpack_public_path__ + "static/lebanon-28fc7c24911e2098790806e8ab78e409.svg";